var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('card-header',{attrs:{"title":"Application Details","icon":"fa-file-certificate"}}),_c('card-body',[(_vm.loaded)?_c('application-view',{attrs:{"application":_vm.application,"applicant":_vm.applicant}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }